<script>
import { connect } from 'vuex-connect';
import ReviewBox from '../scenes/ReviewBox.vue';

export default connect({
  gettersToProps: {
    game: 'reviewingGame',
  },
  actionsToEvents: {
    rate: 'rateGame',
    skip: 'rateGame',
  },
})('ReviewBox', ReviewBox);
</script>
